import { useListEventTicketTemplatesQuery } from "services/eventTickets";
import { EventTicket } from "../eventTicket";
import { createTemplateDashboard } from 'components/reusable/template';


export const EventTicketDashboard = createTemplateDashboard({
  TemplateRenderer: EventTicket,
  listTemplateHook: useListEventTicketTemplatesQuery,
  i18nNamespace: "eventTicket"
})